<template>
  <div v-if="filter.form">
    <div
      class="modal fade"
      :class="filter.modal ? 'show' : ''"
      style="display: block"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Filter</h5>
            <button type="button" class="close" v-on:click="triggerFilter" v-html="loading && filter.requested ? spin() : ic('close')"/>
          </div>
          <div class="modal-body pt-3">
            <div class="row">

              <!-- GROUP FILTER -->
              <div class="form-group col-12">
                <label class="form-label" :class="group.length == 0 ? 'label-fade' : ''">
                  Pilih Group <span class="pull-right" v-html="loading && group.length == 0  ? spin() : ''"></span>
                </label>
                <selectize 
                  v-model="filter.group_by" 
                  data-placeholder="Pilih Group" 
                  :disabled="group.length == 0"
                >
                  <option :value="d" v-for="(d, i) in group" :key="i">{{d}}</option>
                </selectize>
              </div>

              <!-- PERUSAHAAN FILTER -->
              <div class="form-group col-12">
                <label class="form-label" :class="perusahaan.length == 0 ? 'label-fade' : ''">
                  Pilih Perusahaan <span class="pull-right" v-html="loading && perusahaan.length == 0  ? spin() : ''"></span>
                </label>
                <selectize 
                  v-model="filter.id_perusahaan" 
                  data-placeholder="Pilih Perusahaan" 
                  :settings="selectConfig" 
                  :disabled="perusahaan.length == 0"
                  @input="_getDepo"
                >
                  <option :value="d.id" v-for="(d, i) in perusahaan" :key="i">{{d.nama_perusahaan}}</option>
                </selectize>
              </div>

              <!-- DEPO FILTER -->
              <div class="form-group col-12" v-if="depo.length > 0">
                <label class="form-label" :class="depo.length == 0 ? 'label-fade' : ''">
                  Pilih Depo <span class="pull-right" v-html="loading && depo.length == 0  ? spin() : ''"></span>
                </label>
                <selectize 
                  v-model="filter.id_depo" 
                  data-placeholder="Pilih Depo" 
                  :settings="selectConfig" 
                  :disabled="depo.length == 0"
                  @input="_getSalesman"
                >
                  <option :value="d.id" v-for="(d, i) in depo" :key="i">{{d.nama_depo}}</option>
                </selectize>
              </div>

              <!-- SALESMAN FILTER -->
              <div class="form-group col-12" v-if="salesman.length > 0">
                <label class="form-label" :class="salesman.length == 0 ? 'label-fade' : ''">
                  Pilih Salesman <span class="pull-right" v-html="loading && salesman.length == 0  ? spin() : ''"></span>
                </label>
                <selectize 
                  v-model="filter.id_salesman" 
                  data-placeholder="Pilih Salesman" 
                  :settings="selectConfig" 
                  :disabled="salesman.length == 0"
                >
                  <option :value="d.id" v-for="(d, i) in salesman" :key="i">{{d.nama_salesman+' '+'('+d.tim+')'}}</option>
                </selectize>
              </div>

              <!-- GUDANG FILTER -->
              <div class="form-group col-12">
                <label class="form-label" :class="gudang.length == 0 ? 'label-fade' : ''">
                  Pilih Gudang <span class="pull-right" v-html="loading && gudang.length == 0  ? spin() : ''"></span>
                </label>
                <selectize 
                  v-model="filter.id_gudang" 
                  data-placeholder="Pilih Gudang" 
                  :settings="selectConfig" 
                  :disabled="gudang.length == 0"
                >
                  <option :value="d.id" v-for="(d, i) in gudang" :key="i">{{d.nama_gudang}}</option>
                </selectize>
              </div>

              <!-- PRINCIPAL FILTER -->
              <div class="form-group col-12">
                <label class="form-label" :class="principal.length == 0 ? 'label-fade' : ''">
                  Pilih Principal <span class="pull-right" v-html="loading && principal.length == 0  ? spin() : ''"></span>
                </label>
                <selectize 
                  v-model="filter.id_principal" 
                  data-placeholder="Pilih Principal" 
                  :settings="selectConfig" 
                  :disabled="principal.length == 0"
                  @input="_getBrand"
                >
                  <option :value="d.id" v-for="(d, i) in principal" :key="i">{{d.nama_principal}}</option>
                </selectize>
              </div>

              <!-- BRAND FILTER -->
              <div class="form-group col-12" v-if="brand.length>0">
                <label class="form-label" :class="brand.length == 0 ? 'label-fade' : ''">
                  Pilih Brand <span class="pull-right" v-html="loading && brand.length == 0  ? spin() : ''"></span>
                </label>
                <selectize 
                  v-model="filter.id_brand" 
                  data-placeholder="Pilih Brand" 
                  :settings="selectConfig" 
                  :disabled="brand.length == 0"
                  @input="_getBarang"
                >
                  <option :value="d.id" v-for="(d, i) in brand" :key="i">{{d.nama_brand}}</option>
                </selectize>
              </div>

              <!-- BARANG FILTER -->
              <div class="form-group col-12" v-if="barang.length>0">
                <label class="form-label" :class="barang.length == 0 ? 'label-fade' : ''">
                  Pilih Barang <span class="pull-right" v-html="loading && barang.length == 0  ? spin() : ''"></span>
                </label>
                <selectize 
                  v-model="filter.id_barang" 
                  data-placeholder="Pilih Barang" 
                  :settings="selectConfig" 
                  :disabled="barang.length == 0"
                >
                  <option :value="d.id" v-for="(d, i) in barang" :key="i">{{d.nama_barang}}</option>
                </selectize>
              </div>

              <!-- MITRA FILTER -->
              <div class="form-group col-12">
                <label class="form-label" :class="mitra.length == 0 ? 'label-fade' : ''">
                  Pilih Mitra <span class="pull-right" v-html="loading && mitra.length == 0  ? spin() : ''"></span>
                </label>
                <selectize 
                  v-model="filter.id_mitra" 
                  data-placeholder="Pilih Mitra" 
                  :settings="selectConfig" 
                  :disabled="mitra.length == 0"
                >
                  <option :value="d.id" v-for="(d, i) in mitra" :key="i">{{d.perusahaan}}</option>
                </selectize>
              </div>

              <!-- DATE FILTER START DATE-->
              <div class="form-group col-6">
                <label for="tanggal-mulai" class="form-label" v-html="'Mulai Tanggal'"/>
                <input
                  id="tanggal-mulai"
                  type="date"
                  class="form-control"
                  required
                  v-model="filter.start_date"
                  :max="filter.end_date"
                />
              </div>

              <!-- DATE FILTER END DATE-->
              <div class="form-group col-6">
                <label for="tanggal-selesai" class="form-label" v-html="'Sampai Tanggal'"/>
                <input
                  id="tanggal-selesai"
                  type="date"
                  class="form-control"
                  required
                  v-model="filter.end_date"
                  :max="dateTime('ymd')"
                />
              </div>

            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-white" @click="triggerFilter"  v-html="loading && filter.requested ? spin() : 'Tutup'"/>
            <button type="button" class="btn btn-primary" @click="fetchData(); triggerFilter()" v-html="'OK'"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions} from "vuex";
import helper from "@/assets/js/helper.js";

export default {
  name: "Modal",
  mixins: [helper],
  computed: {
    ...mapState(["loading","selectizeConfig"]),
    ...mapState("monitoring_retur", {
      filter: (state) => state.filter,
    }),
  },
  data() {
    return {
      perusahaan: [],
      principal: [],
      salesman : [],
      gudang: [],
      barang: [],
      mitra : [],
      brand: [],
      depo: [],
      group : [
        'Perusahaan',
        'Depo',
        'Gudang',
        'Salesman',
        'Principal',
        'Brand',
        'Barang'
      ],
    };
  },

  methods: {
    ...mapActions('monitoring_retur', ['triggerFilter','fetchData']),
    ...mapActions('perusahaan', ['getListPerusahaanByAccess']),
    ...mapActions('depo', ['getListDepo']),
    ...mapActions('mitra', ['getListMitra']),
    ...mapActions('principal', ['getListPrincipal']),
    ...mapActions('brand', ['getListBrand']),
    ...mapActions('barang', ['getListBarangByBrand']),
    ...mapActions("gudang", ["getListGudang"]),
    ...mapActions('salesman', ['getListSalesman']),

    _getPerusahaan() {
      this.getListPerusahaanByAccess().then( res => {
        this.perusahaan = res
      })
    },
    _getDepo(){
      this.getListDepo({filter: false, id_perusahaan: this.filter.id_perusahaan}).then( res => {
        this.depo = res
      })
    },
    _getMitra(){
      this.getListMitra().then( res => {
        this.mitra = res
      })
    },

    _getPrincipal() {
      this.getListPrincipal({ id_perusahaan: this.filter.id_perusahaan }).then((res) => {
        this.principal = res;
      });
    },

    _getBrand() {
      this.getListBrand({id_principal: this.filter.id_principal, per_page: "all"}).then((res) => {
        this.brand = res;
      });
    },

    _getBarang() {
      this.getListBarangByBrand({ id_brand: this.filter.id_brand }).then((res) => {
        this.barang = res.data;
      });
    },

    _getGudang() {
      this.getListGudang().then((res) => {
        this.gudang = res
      });
    },

    _getSalesman(){
      this.getListSalesman({id_perusahaan: this.filter.id_perusahaan, depo: this.filter.depo}).then( res => {
        this.salesman = res
      })
    },
  },
  mounted: function() {
    this._getPrincipal()
    this._getGudang()
    this._getMitra()
    this._getPerusahaan()
  },
};
</script>
<style>
  .label-fade{
    opacity: 0.5;
  }
</style>